import {
  GET_VERIFICATION_LINK,
  GET_VERIFICATION_LINK_SUCCESS,
  GET_VERIFICATION_LINK_FAIL,
  CHECK_KYC_STATUS,
  CHECK_KYC_STATUS_SUCCESS,
  CHECK_KYC_STATUS_FAIL,
} from './actionTypes';

const initialState = {
  loading: false,
  error: null,
  verificationUrl: null,
  kycStatus: null,
  reviewResult: null,
  checkingStatus: false,
};

const KYC = (state = initialState, action) => {
  switch (action.type) {
    case GET_VERIFICATION_LINK:
      return {
        ...state,
        loading: true,
        error: null,
        verificationUrl: null,
      };
    case GET_VERIFICATION_LINK_SUCCESS:
      console.log('Reducer: Setting verification URL:', action.payload);
      return {
        ...state,
        loading: false,
        verificationUrl: action.payload,
        error: null,
      };
    case GET_VERIFICATION_LINK_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        verificationUrl: null,
      };
    case CHECK_KYC_STATUS:
      return {
        ...state,
        checkingStatus: true,
        error: null,
      };
    case CHECK_KYC_STATUS_SUCCESS:
      return {
        ...state,
        checkingStatus: false,
        error: null,
      };
    case CHECK_KYC_STATUS_FAIL:
      return {
        ...state,
        checkingStatus: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default KYC;
